import Resources from './resources';
import modalActions from '../containers/modal-container/modal-actions';
import invalidRequestActions from '../containers/app/errors/invalid-request-actions';

const DEFAULT_MSG = 'Something went wrong...';

/**
 * Global error handling for 3p resources requests
 * Checks the HTTP status code of the response and logs error & displays error modal
 * if not a success code
 */
class ErrorHandling {
    static addResourceResponseErrorInterceptor(dispatch) {
        const interceptor = ErrorHandling.handleErrors.bind(this, dispatch);
        Resources.env.addResponseInterceptor(interceptor);
    }

    static handleErrors(dispatch, result) {
        let message;
        let valid = false;

        try {
            switch (result.status) {
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                    valid = true;
                    break;

                default:
                    message = this.getErrorMessage(result);
            }
        } catch (e) {
            const i18n = window.i18n;
            message = i18n._('Message - SomethingWrong');
        }

        if (valid === false) {
            console.error(message); // eslint-disable-line no-console
            const i18n = window.i18n;
            dispatch(
                modalActions.openModal({
                    content: message,
                    buttons: [
                        {
                            text: i18n._('Label - OK'),
                            primary: true,
                            handler: () => {
                                dispatch(
                                    invalidRequestActions.invalidRequestMade()
                                );
                                dispatch(modalActions.closeModal());
                            }
                        }
                    ]
                })
            );
        }

        // still want actions creators to have access to the response incase they need to do
        // anything special, so we add valid property they can access to check the status
        result.valid = valid;

        return result;
    }

    static getErrorMessage(response) {
        if (response.data) {
            return this.getMessageString(response.data);
        } else if (response.message) {
            return this.getMessageString(response.message);
        }
        return DEFAULT_MSG;
    }

    static getMessageString(item) {
        if (item.message && typeof item.message === 'string') {
            return item.message;
        } else if (typeof item === 'string') {
            return item;
        }
        return DEFAULT_MSG;
    }
}

export default ErrorHandling;



// WEBPACK FOOTER //
// ./helpers/error-handling.js